<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <p class="title">分类名称</p>
      <div class="block">
        <input class="input width-2" v-model="params.name"/>
      </div>
      <p class="title">分类描述(后台备注用)</p>
      <div class="block">
        <input class="input width-2" v-model="params.remark">
      </div>
      <p class="title">显示状态</p>
      <div class="block">
        <input type="radio" value="1" v-model="params.status">开启
        <input type="radio" value="0" v-model="params.status">关闭
      </div>
      <p class="title">分类图片</p>
      <div class="block">
        <span class="button is-primary" style="line-height: 30px;" id="js_imageUploadBtn">上传图片</span>
        <span class="upload-img-tips">建议尺寸：336＊128px(图片尺寸小于1M)</span>
      </div>
      <div class="block">
        <image-component :image="params.image" :width="200" :compress="1.2"></image-component>
      </div>
      <div class="block">
        <button class="button" @click="cancelEdit">取消</button>
        <button class="button is-info" @click="saveEdit" style="margin-left: 30px;">保存</button>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'

export default {
  components: {

  },
  data () {
    return {
      categoryId: 0,
      params: {
        name: '',
        remark: '',
        status: 1,
        image: {
          image: '',
          width: 0,
          height: 0
        }
      }
    }
  },
  mounted () {
    this.categoryId = this.$route.query.categoryId
    if (this.categoryId > 0) {
      this.getTopicCategory()
    }
    this.uploadMainBind()
  },
  methods: {
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.params.image.image = response.data.images.info.path
            this.params.image.width = response.data.images.info.width
            this.params.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    // 获取专题分类详情
    getTopicCategory () {
      HttpRequest.post('/admin.php?method=blogger.getTopicCategory', {categoryId: this.categoryId}, true).then((response) => {
        this.params = response.data
      }, (response) => {

      })
    },
    // 保存编辑
    saveEdit () {
      let params = Object.assign({}, this.params)
      params.categoryId = this.categoryId
      if (!params.name) {
        this.$message('请输入分类名称')
        return
      }
      if (!params.image.image) {
        this.$message('请上传分类图片')
        return
      }
      HttpRequest.post('/admin.php?method=blogger.doSaveTopicCategory', params, true).then((response) => {
        this.$router.push('/cyzsTopic/topicCategorieList/')
      }, (response) => {

      })
    },
    cancelEdit () {
      this.$router.push('/cyzsTopic/topicCategorieList/')
    }
  }
}
</script>
<style lang="less">
  .upload-img-tips{
    position: relative;
    top: 10px;
    color: #ff0000;
  }
</style>
